import { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

const REFERRAL_STORAGE_KEY = "referralAddress";
const CURRENT_WALLET_STORAGE_KEY = "currentWalletAddress";

export const useReferral = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const referralAddress = urlParams.get("ref");

    if (referralAddress) {
      const isValidAddress = /^0x[a-fA-F0-9]{40}$/.test(referralAddress);

      if (isValidAddress) {
        localStorage.setItem(
          REFERRAL_STORAGE_KEY,
          referralAddress.toLowerCase()
        );

        // Redirect to lottery page after capturing referral
        // history.replace("/lucky-draw");
      }
    }
  }, [location.search, history]);

  const getReferralAddress = (): string | null => {
    return localStorage.getItem(REFERRAL_STORAGE_KEY);
  };

  const clearReferralAddress = (): void => {
    localStorage.removeItem(REFERRAL_STORAGE_KEY);
  };

  const saveCurrentWalletAddress = (walletAddress: string): void => {
    if (walletAddress) {
      localStorage.setItem(
        CURRENT_WALLET_STORAGE_KEY,
        walletAddress.toLowerCase()
      );
    }
  };

  const getCurrentWalletAddress = (): string | null => {
    return localStorage.getItem(CURRENT_WALLET_STORAGE_KEY);
  };

  const generateReferralLink = (walletAddress?: string): string => {
    const baseUrl = window.location.origin;
    const address = walletAddress || getCurrentWalletAddress();
    return address ? `${baseUrl}?ref=${address.toLowerCase()}` : "";
  };

  return {
    getReferralAddress,
    clearReferralAddress,
    saveCurrentWalletAddress,
    getCurrentWalletAddress,
    generateReferralLink,
  };
};

export default useReferral;
